export default __webpack_public_path__ + "static/media/020-muay thai.60d83e2b.svg";